module.exports = __webpack_public_path__ + "static/assets/1b82381ee9acfa07343530149029e2d6.png";